import { combineReducers } from "redux";
import { _AdminAuth } from "./authReducer";
import _blogReducer from "./blog.reducer";
import { themeReducer } from "./globalReducer";

export default combineReducers({
    themeToggle: themeReducer,
    adminAuth: _AdminAuth,
    blog: _blogReducer,
})